export const modalStyles = {
    imagesContainer: {
        gap: '24px',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        margin: '30px'
    }
};
